import { FC } from "react";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

const DeleteEverythingDialog: FC<{
  open: boolean;
  handleClose: () => void;
}> = ({ open, handleClose }) => {
  const handleDelete = () => {
    localStorage.clear();
    window.location.reload();
  };

  return (
    <Dialog open={open} maxWidth={"sm"} onClose={handleClose}>
      <DialogTitle>Alles löschen?</DialogTitle>

      <DialogContent>
        <DialogContentText>
          Für den Fall das irgendetwas nicht richtig funktioniert kann es
          helfen, alle lokal gespeicherten Daten zu löschen.
          <br />
          <strong>
            Dadurch werden alle Spiele und Einstellungen entfernt.
          </strong>
        </DialogContentText>
        <Alert severity="warning" sx={{ mt: 2 }}>
          Diese Aktion kann nicht rückgängig gemacht werden
        </Alert>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Abbrechen</Button>
        <Button onClick={handleDelete} color={"error"}>
          Löschen
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteEverythingDialog;
